import React, { Component } from "react";
import { Link } from "react-router-dom";
import Aux from "../../../../hoc/Auxilliary";
import { Modal, Button } from "react-bootstrap";
import { getMisc } from "../../../../localstorage-service";
import RequiredField from "../../../Admin/AdminMainContent/Common/RequiredField";
import {
  getUser,
  getCountries,
  getStates,
  getLanguages,
  updateUser
} from "../../../../data-service";
import Spinner from "../../Common/Spinner/Spinner";
import {
  emptyCheck,
  validateEmail,
  validatePassword
} from "../../../../utilities";

class Header extends Component {
  state = {
    show: false,
    showProfile: false,
    selectedUser: {},
    countries: [],
    languages: [],
    states: [],
    statesByCountry: [],
    error: false,
    errorMessage: "",
    showSpinner: false,
    successMessage: ""
  };

  showSpinner(isShow) {
    this.setState({
      showSpinner: isShow
    });
  }
  handleLogoutClick = () => {
    localStorage.setItem("token", "");
    this.props.history.push("/login");
  };

  getCountriesForR(resolve, reject) {
    let arrCountries = [];
    getCountries()
      .then(response => {
        for (let country of response.data) {
          arrCountries.push(
            <option key={country.Id} value={country.Id}>
              {country.Name}
            </option>
          );
        }
        this.setState({ countries: arrCountries });
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  }

  getStatesForR(resolve, reject) {
    let arrStates = [];
    getStates()
      .then(response => {
        for (let state of response.data) {
          arrStates.push(state);
        }
        this.setState({ states: arrStates });
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  }

  getLanguagesForR(resolve, reject) {
    let arrLanguages = [];
    getLanguages()
      .then(response => {
        for (let language of response.data) {
          arrLanguages.push(
            <option key={language.Id} value={language.Id}>
              {language.Name}
            </option>
          );
        }
        this.setState({ languages: arrLanguages });
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  }
  countryChanged(event) {
    this.countryChangedHandle(event.target.value);
  }

  countryChangedHandle(id) {
    let arrStates = [];
    let states = this.state.states.filter(
      d => d.CountryId === parseInt(id, 10)
    );
    for (let state of states) {
      arrStates.push(
        <option key={state.Id} value={state.Id}>
          {state.Name}
        </option>
      );
    }
    this.setState({ statesByCountry: arrStates });
  }

  handleClose = () => {
    this.setState({ show: false });
  };

  handleShow = () => {
    this.setState({ show: true });
  };

  handleProfileClose = () => {
    this.setState({ showProfile: false });
  };

  handleProfileShow = () => {
    const that = this;
    this.showSpinner(true);

    const promise1 = new Promise(function(resolve, reject) {
      that.getCountriesForR(resolve, reject);
    });
    const promise2 = new Promise(function(resolve, reject) {
      that.getStatesForR(resolve, reject);
    });
    const promise3 = new Promise(function(resolve, reject) {
      that.getLanguagesForR(resolve, reject);
    });
    const promises = Promise.all([promise1, promise2, promise3]);

    promises
      .then(function(results) {
        getUser()
          .then(response => {
            that.countryChangedHandle(response.data.CountryId);
            that.setState({
              error: false,
              errorMessage: "",
              successMessage: "",
              showProfile: true,
              selectedUser: response.data
            });
            that.showSpinner(false);
          })
          .catch(error => {
            // console.log(error);
            that.showSpinner(false);
            //that.props.showError(error);
            alert(error);
          });
      })
      .catch(error => {
        // console.log(error);
        that.showSpinner(false);
        //that.props.showError(error);
        alert(error);
      });
  };
  validate(data) {
    // console.log(data);
    if (emptyCheck(data.Name)) {
      this.setState({
        successMessage: "",
        errorMessage: getMisc("vnameblank")
      });
      return false;
    }
    if (emptyCheck(data.Email)) {
      this.setState({
        successMessage: "",
        errorMessage: getMisc("vemailblank")
      });
      return false;
    }
    if (emptyCheck(data.Password)) {
      this.setState({
        successMessage: "",
        errorMessage: getMisc("vpasswordblank")
      });
      return false;
    }
    if (data.LanguageId === "-1") {
      this.setState({
        successMessage: "",
        errorMessage: getMisc("vlanguageblank")
      });
      return false;
    }
    if (data.CountryId === "-1") {
      this.setState({
        successMessage: "",
        errorMessage: getMisc("vcountryblank")
      });
      return false;
    }
    if (data.StateId === "-1") {
      this.setState({
        successMessage: "",
        errorMessage: getMisc("vstateblank")
      });
      return false;
    }
    if (!validateEmail(data.Email)) {
      this.setState({
        successMessage: "",
        error: true,
        errorMessage: getMisc("vemailinvalid")
      });
      return false;
    }
    if (data.IsPasswordChanged) {
      if (!validatePassword(data.Password)) {
        this.setState({
          successMessage: "",
          error: true,
          errorMessage: getMisc("vprofilesuccess")
        });
        return false;
      }
    }
    return true;
  }
  saveUser() {
    const data = {
      Id: this.state.action === "edit" ? this.state.selectedUser.Id : 0,
      Name: this.refs["txtName"].value,
      Email: this.refs["txtEmail"].value,
      Password: this.refs["txtPassword"].value,
      EmailConfirmed: true,
      LanguageId: this.refs["selLanguage"].value,
      CountryId: this.refs["selCountry"].value,
      StateId: this.refs["selState"].value,
      IsPasswordChanged:
        this.state.selectedUser.Password === this.refs["txtPassword"].value
          ? false
          : true,
      IsApproved: true,
      IsFrontend: true
    };
    // console.log(data);
    if (this.validate(data)) {
      this.showSpinner(true);
      updateUser(data)
        .then(response => {
          this.showSpinner(false);
          // console.log(response);
          this.setState({
            error: false,
            errorMessage: "",
            successMessage: getMisc("vprofilesuccess")
          });
        })
        .catch(error => {
          this.showSpinner(false);
          // console.log(error);
          let errorMessage;
          if (error.response) {
            errorMessage = error.response.data.InnerException
              ? error.response.data.InnerException.InnerException
                  .ExceptionMessage
              : error.response.data.ExceptionMessage;
            errorMessage = error.response.data.Message + " " + errorMessage;
            this.setState({
              error: true,
              errorMessage: errorMessage
            });
          }
        });
    }
  }
  render() {
    let errorPlaceholder;
    if (this.state.errorMessage && this.state.errorMessage.trim().length > 0) {
      errorPlaceholder = (
        <p className="alert alert-danger">{this.state.errorMessage}</p>
      );
    } else {
      errorPlaceholder = null;
    }
    let successPlaceholder;
    if (
      this.state.successMessage &&
      this.state.successMessage.trim().length > 0
    ) {
      successPlaceholder = (
        <p className="alert alert-success">{this.state.successMessage}</p>
      );
    }

    return (
      <Aux>
        <div className="container">
          <Spinner showSpinner={this.state.showSpinner} />
          <div className="col-xs-12">
            <div className="row">
              <div className="col-lg-8 col-md-7 col-sm-7 col-xs-3">
                <div className="row pull-left">
                  <h2>
                    <Link to="/">
                      <span>{getMisc("cyroem")}</span>{" "}
                      <span className="hidden-sm hidden-xs">
                        | {getMisc("learning")}
                      </span>{" "}
                      <span className="hidden-sm hidden-xs">
                        | {getMisc("samplepreparation")}
                      </span>
                    </Link>
                  </h2>
                </div>
              </div>
              <div className="col-lg-4 col-md-5 col-sm-5 col-xs-9">
                <div className="row">
                  <ul>
                    <li>
                      <Link to="/">{getMisc("menu")}</Link>|
                    </li>
                    <li>
                      <a
                        onClick={() => {
                          this.setState({ show: true });
                        }}
                      >
                        {getMisc("jobaid")}
                      </a>
                      |
                    </li>
                    <li>
                      <a
                        onClick={() => {
                          this.handleProfileShow();
                        }}
                      >
                        {getMisc("profile")}
                      </a>
                      |
                    </li>
                    <li>
                      <a onClick={this.handleLogoutClick}>
                        {getMisc("logout")}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{getMisc("jobaidheading")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p dangerouslySetInnerHTML={{ __html: getMisc("jobaidtext") }} />
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleClose}>{getMisc("close")}</Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.showProfile} onHide={this.handleProfileClose}>
          <Modal.Header closeButton>
            <Modal.Title>{getMisc("profile")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {errorPlaceholder}
            {successPlaceholder}
            <div className="form-group">
              <label>
                <RequiredField />
                {getMisc("name")}:
              </label>
              <input
                maxLength="50"
                type="text"
                className="form-control"
                ref="txtName"
                defaultValue={this.state.selectedUser.Name}
              />
            </div>
            <div className="form-group">
              <label>
                <RequiredField />
                {getMisc("email")}:
              </label>
              <input
                maxLength="100"
                disabled="disabled"
                type="text"
                className="form-control"
                ref="txtEmail"
                defaultValue={this.state.selectedUser.Email}
              />
            </div>
            <div className="form-group">
              <label>
                <RequiredField />
                {getMisc("password")}:
              </label>
              <input
                maxLength="100"
                type="password"
                className="form-control"
                ref="txtPassword"
                defaultValue={this.state.selectedUser.Password}
              />
            </div>
            <div className="form-group">
              <label>
                <RequiredField />
                {getMisc("language")}:
              </label>
              <select
                ref="selLanguage"
                className="form-control"
                defaultValue={this.state.selectedUser.LanguageId}
              >
                <option value={-1}>Select Language</option>
                {this.state.languages}
              </select>
            </div>
            <div className="form-group">
              <label>
                <RequiredField />
                {getMisc("country")}:
              </label>
              <select
                ref="selCountry"
                className="form-control"
                defaultValue={this.state.selectedUser.CountryId}
                onChange={event => this.countryChanged(event)}
              >
                <option value={-1}>Select Country</option>
                {this.state.countries}
              </select>
            </div>
            <div className="form-group">
              <label>
                <RequiredField />
                {getMisc("state")}:
              </label>
              <select
                ref="selState"
                className="form-control"
                defaultValue={this.state.selectedUser.StateId}
              >
                <option value={-1}>Select State</option>
                {this.state.statesByCountry}
              </select>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleProfileClose}>
              {getMisc("close")}
            </Button>
            <Button className="btn-primary" onClick={() => this.saveUser()}>
              {getMisc("save")}
            </Button>
          </Modal.Footer>
        </Modal>
      </Aux>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/containers/User/Common/Header/Header.js